@let ranges = listStore.editingRangesSg();
@let selectedRangeIndex = listStore.selectedRangeIndexSg();

<div class="atn-ds-date-multi-range-header">
  <i
    class="atn-icon atn-plus atn-blue"
    (click)="addRangeClickHandler()"
  ></i>

  <div class="atn-ds-date-multi-range-header__input-wrapper">
    @if (ranges?.length) {
      <div class="atn-ds-date-multi-range-header__input">
        @for (range of ranges; track $index) {
          <atn-ds-tag
            class="atn-ds-date-multi-range-header__tag"
            [text]="range | formattedDateRange"
            (click)="dateRangeSelectHandler($index)"
            [isSelected]="$index === selectedRangeIndex"
          />
        }
      </div>
    } @else {
      <div class="atn-ds-date-multi-range-header__placeholder">
        Select date ranges...
      </div>
    }
  </div>
  <i
    class="atn-icon atn-trash atn-red"
    (click)="deleteRangeClickHandler()"
  ></i>
</div>
